import { render, staticRenderFns } from "./gantt-componente.vue?vue&type=template&id=a943c9a0"
import script from "./gantt-componente.vue?vue&type=script&lang=js"
export * from "./gantt-componente.vue?vue&type=script&lang=js"
import style0 from "./gantt-componente.vue?vue&type=style&index=0&id=a943c9a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports